import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IState } from '../../../../store';
import { setPhoneCollapse } from '../../../../store/phone_collapse';
import {
  FullScreenControls,
  IFullScreenControlsCommonProps,
  IFullScreenControlsDispatchProps,
  IFullScreenControlsOwnProps,
} from './';
import { getDynamicCalltrackingSiteBlockId } from '../../../../selectors/getDynamicCalltrackingSiteBlockId';
import { getNewbuildingId } from '../../../../selectors';
import { priceSelector } from './selectors';

function mapStateToProps(state: IState) {
  return {
    abGroup: state.abGroup,
    agent: state.offerData.agent,
    kpId: state.offerData.kp && state.offerData.kp.id,
    offer: state.offerData.offer,
    user: state.offerData.user,
    siteBlockId: getDynamicCalltrackingSiteBlockId(state),
    newbuildingId: getNewbuildingId(state),
    isAuthenticated: !!(state.offerData.user && state.offerData.user.isAuthenticated),
    price: priceSelector(state),
    dynamicCalltrackingPlaceType: 'Fotorama',
  };
}

function mapDispatchToProps(dispatch: Dispatch<IState>) {
  return {
    setPhoneCollapse: () => dispatch(setPhoneCollapse()),
  };
}

export const FullScreenControlsContainer = connect<
  IFullScreenControlsCommonProps,
  IFullScreenControlsDispatchProps,
  IFullScreenControlsOwnProps
>(
  mapStateToProps,
  mapDispatchToProps,
)(FullScreenControls);
